import React from 'react'
import PropTypes from 'prop-types'

function ProviderSelector({ providers, currentProvider, conversationId, onProviderChange, locked }) {
  const handleChange = async (e) => {
    if (locked) return

    const newProvider = e.target.value

    // If no conversation yet, just update local state
    if (!conversationId) {
      if (onProviderChange) {
        onProviderChange(newProvider)
      }
      return
    }

    // Update via PATCH request
    try {
      const csrfToken = document.querySelector('[name="csrf-token"]')?.content
      const response = await fetch(`/ai_conversations/${conversationId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken || ''
        },
        body: JSON.stringify({
          ai_conversation: { ai_provider: newProvider }
        })
      })

      if (response.ok) {
        // Reload to apply the change
        window.location.reload()
      } else {
        const errorData = await response.json().catch(() => ({}))
        console.error('Failed to update provider:', response.status, errorData)
        alert('Failed to change provider. Please try again.')
      }
    } catch (error) {
      console.error('Failed to update provider:', error)
      alert('Failed to change provider. Please try again.')
    }
  }

  const getProviderLabel = (provider) => {
    switch (provider) {
      case 'claude':
        return 'Claude (Anthropic)'
      case 'gemini':
        return 'Gemini (Google)'
      case 'openai':
        return 'GPT-5.2 (OpenAI)'
      default:
        return provider
    }
  }

  return (
    <div className="ai-provider-selector">
      <label htmlFor="ai-provider">AI Provider:</label>
      <select
        id="ai-provider"
        value={currentProvider}
        onChange={handleChange}
        className="ai-provider-select"
        disabled={locked}
        title={locked ? 'Provider cannot be changed once a conversation has started' : ''}
      >
        {providers.map((provider) => (
          <option key={provider} value={provider}>
            {getProviderLabel(provider)}
          </option>
        ))}
      </select>
    </div>
  )
}

ProviderSelector.propTypes = {
  providers: PropTypes.array.isRequired,
  currentProvider: PropTypes.string.isRequired,
  conversationId: PropTypes.number,
  onProviderChange: PropTypes.func,
  locked: PropTypes.bool
}

export default ProviderSelector
